import lib from 'lib';
import _ from 'lodash';

export const loadTagsData = async ({resourceActions, params, mode}) => {
  const {trackTags, trackTagCategories} = resourceActions;

  const tags = await lib.api.get('tags', {where: {deleted: 0}});
  const tagCategories = await lib.api.get('tagCategories', {where: {deleted: 0}});

  await trackTags({tags});
  await trackTagCategories({tagCategories});
};

export const loadMedia = async ({resourceActions, where, pageNumber = 1, pageCount = 50, projectId, reset = false}) => {
  const {trackMedia} = resourceActions;
  const baseWhere = {
    type: ['image', 'vimage'],
    deleted: 0,
    projectId,
  };

  //TODO pull media based on params and queryParams
  where = _.defaultsDeep(where, baseWhere);

  const order = [{field: 'id', direction: 'desc'}];
  const {data: {media}} = await lib.api.request({uri: 'media/get', body: {
    where, order,
    page: {
      number: pageNumber,
      count: pageCount
    }
  }});

  //TODO test this in staging to see if it makes a difference for performance, if not we should remove this _.forEach
  _.forEach(media, medium => {
    const img = new Image();

    img.src = medium.url;
  });

  await trackMedia({media, reset});

  return {media, hasMore: media?.length >= pageCount};
};

export const loadProjects = async ({resourceActions, where}) => {
  const {trackProjects} = resourceActions;
  const baseWhere = {
    deleted: 0,
  };

  where = _.defaultsDeep(where, baseWhere);

  const projects = await lib.api.get('projects', {where});

  await trackProjects({projects, reset: true});

  return {projects};
};
